// biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration - should be fixed
declare var platform: any;
// biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration - should be fixed
declare var µ: any;

export class IsHelper {
	// biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration - should be fixed
	visCheckLaptop: any = null;
	// biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration - should be fixed
	visCheckDesktop: any = null;

	constructor() {
		this.visCheckLaptop = document.querySelector('#vis-check-laptop');
		this.visCheckDesktop = document.querySelector('#vis-check-desktop');
	}

	public laptop() {
		return this.vanillaVisCheck(this.visCheckLaptop);
	}

	public desktop() {
		return this.vanillaVisCheck(this.visCheckDesktop);
	}

	// biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration - should be fixed
	public vanillaVisCheck(elem: any) {
		return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
	}

	public date(date: Date) {
		return date instanceof Date && !isNaN(date.valueOf());
	}

	// biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration - should be fixed
	public function(functionToCheck: any) {
		var getType = {};
		return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
	}

	public safari() {
		return /^((?!chrome).)*safari/i.test(navigator.userAgent);
	}
	public fireFox() {
		// biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration - should be fixed
		return typeof (window as any).InstallTrigger !== 'undefined';
		//return /firefox/i.test(navigator.userAgent);
	}
	public chrome() {
		// biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration - should be fixed
		return !!(window as any).chrome && !!(window as any).chrome.webstore;
	}
	public IE() {
		var ua = window.navigator.userAgent;

		var msie = ua.indexOf('MSIE ');
		if (msie > 0) {
			// IE 10 or older => return version number
			return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
		}

		var trident = ua.indexOf('Trident/');
		if (trident > 0) {
			// IE 11 => return version number
			var rv = ua.indexOf('rv:');
			return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
		}

		var edge = ua.indexOf('Edge/');
		if (edge > 0) {
			// IE 12 => return version number
			return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
		}

		// other browser
		return false;
	}

	public edge() {
		return navigator.mediaDevices && navigator.userAgent.indexOf('Edge/') > -1;
	}

	public today(indate) {
		var today = new Date();
		if (indate.getDate() == today.getDate() && indate.getMonth() == today.getMonth() && indate.getFullYear() == today.getFullYear()) {
			return true;
		} else {
			return false;
		}
	}
	public webRtcCompatable() {
		return (
			typeof navigator['mediaDevices'] === 'object' && typeof navigator['mediaDevices']!.getUserMedia === 'function' && !this.edge()
		);
	}

	public iosApp = function () {
		return µ.Env.Platform === 'iOS';
	};
	public androidApp = function () {
		return µ.Env.Platform === 'Android';
	};
	public app = function () {
		return this.IsAndroidApp() || this.IsIosApp();
	};
	public ios = function () {
		let isIpad = /Macintosh/i.test(navigator.userAgent) && navigator.maxTouchPoints && navigator.maxTouchPoints > 1;
		if (platform.os.family === 'iOS' || isIpad) {
			return true;
		}
		return false;
		//return /(iPad|iPhone|iPod)/g.test(navigator.userAgent);
	};
	public android = function () {
		if (platform.os.family === 'Android') {
			return true;
		}
		return false;
		//var ua = window.navigator.userAgent.toLowerCase();
		//return ua.indexOf("android") > -1;
	};
}
